import { css } from '@emotion/react'

const S = {
  basic: css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    > label:first-of-type {
      margin-left: 0;
      margin-right: 4px;
    }
    > label {
      margin: 0 4px;
    }
    > label:last-of-type {
      margin-right: 0;
      margin-left: 4px;
    }
    > label:only-of-type {
      margin: 0;
    }
  `,
}

export default S
